export default {
  namespaced: true,
  holliday: {
    title: "holliday | hollidays",
    date: "date",
  },
};
